import React, { Component } from "react";
import { Link } from "react-router-dom";
import Constant from "../../Constant";
import $ from "jquery";

export default class AddDomain extends Component {
  state = {
    name: "",
  };
  onSave = () => {
    var that = this;
    that.setState({ isSaving: true });
    if (that.state.accepted) {
      that.uploadImg();
    } else {
      that.createDomain(that.state.MediumId);
    }
  }
  uploadImg = () => {
    var that = this;
    var form = $('#domainLogo')[0];
    var data = new FormData(form);
    data.append("siteId", localStorage.getItem("lms_site_id"));
    fetch(Constant.getAPI() + "/media/addGlobal", {
      method: "post",
      headers: {
        "Authorization": localStorage.getItem("livelms_auth")
      },
      body: data
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      if (json.status === true) {
        that.setState({ MediumId: json.data[0].id });
        that.createDomain(json.data[0].id);
      } else {
        console.log(json.error);
      }
    });
  };
  createDomain = (media_id) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));
    var data = {
      discription: this.state.discription,
    };

    var urlencoded = new URLSearchParams();
    urlencoded.append("name", this.state.name);
    urlencoded.append("description", this.state.discription);
    if (media_id !== undefined && media_id !== null && media_id !== "") {
      urlencoded.append("logo", media_id);
    }
    urlencoded.append("data", JSON.stringify(data));

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/site/add", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        window.location.href = "#/admin/domains/";
      })
      .catch((error) => console.log("error", error));
  };

  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
    console.log(this.state);
  };
  render() {
    return (
      <div className="pt-3">
        <div className="container border shadow-sm p-0 bg-white">
          <div className="header bg-primary text-white">
            <div className="row m-0">
              <div className="col-md-6 p-3 d-flex align-items-center">
                <h5 className="m-0">
                  <Link to="/admin/dashboard">Home</Link> /{" "}
                  <Link to="/admin/domains">Domains</Link> / <b> Add Domain</b>
                </h5>
              </div>
              <div className="col-md-6 d-flex justify-content-end align-items-center">
                {/* <div className="btn btn-dark float-right">Add Course</div> */}
              </div>
            </div>
          </div>

          <div className="row m-0 mt-3">
            <div className="col-md-6">
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Name
                </label>
                <input
                  type="text"
                  class="form-control col-8"
                  placeholder="Enter Name"
                  id="inputDefault"
                  name="name"
                  value={this.state.name}
                  onChange={this.onInputChange}
                />
              </div>
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Description
                </label>
                <textarea
                  type="text"
                  class="form-control col-8"
                  placeholder="Enter Discription"
                  id="inputDefault"
                  name="discription"
                  value={this.state.discription}
                  onChange={this.onInputChange}
                />
              </div>
              <div class="form-group row">
                <label class="col-form-label col-4 text-right" for="inputDefault">
                  Site Logo
              </label>
                <div className="col-8">
                  <form id="domainLogo" name="domainLogo" encType="multipart/form-data" className="text-capitalize">

                    <div className="form-group">

                      <input accept="image/*" onChange={this.handleImageUpload} id="domain_logo" type="file" className="form-control" autoComplete="off" name="media"
                        data-toggle="tooltip" title="Click To Upload Photo"
                      />
                      <div id="domain_logo_lable" className="pt-2">
                        {
                          this.state.image
                            ?
                            this.state.image !== null || this.state.image !== undefined || this.state.image !== {}
                              ?
                              <img src={this.state.image} alt=""
                                height="100" onError={e => {
                                  e.target.src = ""
                                }} />
                              :
                              ''
                            :
                            ''
                        }
                      </div>

                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="p-3 m-0 border-top">
            <div className="btn btn-primary" onClick={this.createDomain}>
              {" "}
              Save
            </div>{" "}
            or <Link to="/admin/domains" className="btn-link">Cancel</Link>
          </div>
        </div>
      </div>
    );
  }
}
